import React from 'react';
import { makeStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import styles from './styles';

export interface TitleDividerProps {
  children: unknown;
  overrideClasses?: CSSObject;
}

const TitleDivider: React.FC<TitleDividerProps> = ({
  children,
  overrideClasses,
}) => {
  const useStyles = makeStyles(styles(overrideClasses));
  const classes = useStyles();

  return (
    <Grid item xs={12} data-testid="title-divider">
      <Typography variant="h6" component="h2" className={classes.title}>
        {children}
      </Typography>
    </Grid>
  );
};

export default TitleDivider;
